export const customShapes = new Map();

export function registerShapeComponent(name: string, Component: any) {
  customShapes.set(name, Component);
}
